var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavingsBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1580_3946)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 28,
    height: 28,
    rx: 6,
    fill: "#886DF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 28,
    height: 28,
    rx: 6,
    fill: "url(#paint0_linear_1580_3946)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 27,
    height: 27,
    rx: 5.5,
    stroke: "url(#paint1_linear_1580_3946)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1562 11.75H18.8125C18.8125 11.0041 18.5162 10.2887 17.9887 9.76126C17.4613 9.23382 16.7459 8.9375 16 8.9375C15.2541 8.9375 14.5387 9.23382 14.0113 9.76126C13.4838 10.2887 13.1875 11.0041 13.1875 11.75H10.8438C10.5951 11.75 10.3567 11.8488 10.1808 12.0246C10.005 12.2004 9.90625 12.4389 9.90625 12.6875V19.7188C9.90625 19.9674 10.005 20.2058 10.1808 20.3817C10.3567 20.5575 10.5951 20.6562 10.8438 20.6562H21.1562C21.4049 20.6562 21.6433 20.5575 21.8192 20.3817C21.995 20.2058 22.0938 19.9674 22.0938 19.7188V12.6875C22.0938 12.4389 21.995 12.2004 21.8192 12.0246C21.6433 11.8488 21.4049 11.75 21.1562 11.75ZM14.125 14.0938C14.125 14.2181 14.0756 14.3373 13.9877 14.4252C13.8998 14.5131 13.7806 14.5625 13.6562 14.5625C13.5319 14.5625 13.4127 14.5131 13.3248 14.4252C13.2369 14.3373 13.1875 14.2181 13.1875 14.0938V13.1562C13.1875 13.0319 13.2369 12.9127 13.3248 12.8248C13.4127 12.7369 13.5319 12.6875 13.6562 12.6875C13.7806 12.6875 13.8998 12.7369 13.9877 12.8248C14.0756 12.9127 14.125 13.0319 14.125 13.1562V14.0938ZM16 9.875C16.4973 9.875 16.9742 10.0725 17.3258 10.4242C17.6775 10.7758 17.875 11.2527 17.875 11.75H14.125C14.125 11.2527 14.3225 10.7758 14.6742 10.4242C15.0258 10.0725 15.5027 9.875 16 9.875ZM18.8125 14.0938C18.8125 14.2181 18.7631 14.3373 18.6752 14.4252C18.5873 14.5131 18.4681 14.5625 18.3438 14.5625C18.2194 14.5625 18.1002 14.5131 18.0123 14.4252C17.9244 14.3373 17.875 14.2181 17.875 14.0938V13.1562C17.875 13.0319 17.9244 12.9127 18.0123 12.8248C18.1002 12.7369 18.2194 12.6875 18.3438 12.6875C18.4681 12.6875 18.5873 12.7369 18.6752 12.8248C18.7631 12.9127 18.8125 13.0319 18.8125 13.1562V14.0938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1580_3946",
    x: 0,
    y: 0.5,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1580_3946"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.284122 0 0 0 0 0.00449997 0 0 0 0 0.8955 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1580_3946"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145413 0 0 0 0 0.0684 0 0 0 0 0.3116 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1580_3946",
    result: "effect2_dropShadow_1580_3946"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1580_3946",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1580_3946",
    x1: 16,
    y1: 1.5,
    x2: 16,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1580_3946",
    x1: 16,
    y1: 1.5,
    x2: 16,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingsBag);
export default __webpack_public_path__ + "static/media/savingsBag.e516cb2318512a140a02397cf8e886f0.svg";
export { ForwardRef as ReactComponent };